// Real hrefs for in-app work-item links.
//
// Anything that opens a work item is an <a href> pointing at the results
// page, not a <div onClick>. The href is what gives the browser its own
// affordances — middle-click and Ctrl/Cmd-click open a new browser tab,
// right-click offers "Copy link", hover shows the destination. Left-click is
// intercepted so plain navigation stays inside the app's tab system. The
// search bar's recently-viewed rows and the Zebra Search grid had no href
// at all, so a middle-click did nothing (2026-09-22).

export function issueResultsHref(key) {
  return `/issues?jql=${encodeURIComponent(`key = ${key}`)}`;
}

export function zebraSearchHref(jql) {
  return `/issues?jql=${encodeURIComponent(jql)}`;
}

// Left-click without modifiers → in-app handler. Anything else (middle,
// Ctrl/Cmd/Shift/Alt) is left to the browser: the href does the work.
export function handleIssueLinkActivation(e, onClick, key) {
  if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  e.preventDefault();
  onClick?.(key);
}
